import React, { useState, useContext } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import API from '../API'
import { DayAllocated, UserDeleteEntryType, UserUpdateEntryType } from '../interfaces';
import { getDayOfWeekName, lookupNameFromObjectsArray } from '../global'
import { SaveDayResponse, ReportingData, ReportingDataDay, DeleteDayResponse, QueryTimeReportRows, InitData, QueryActivities } from '../../../backend/src/api/dto';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isDisabled } from '@testing-library/user-event/dist/utils';




function AdminUploadXLS({ where, table }: {
    where: string,
    table: string
}) {

    const [showModal, closeModal] = useContext(ModalContext);

    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState<{
        name: undefined | string
        base64data: undefined | string
    }>({name: undefined, base64data: undefined});
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)

    const modalButtons = [
        {
            text: 'Nahrať',
            icon: 'upload',
            onClick: () => {
                //setLoading(true);
                API.uploadData(table, { base64data: file.base64data }).then((res) => {
                    console.log(res)
                    setApiResult(null)

                }).catch((e) => {
                    console.log(JSON.stringify(e))
                    setApiResult(e)
                })

            },
            isDisabled: !file.name,
            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];



    const handleUpload = (event: any) => {
        console.log(event)

        if (!event.target.files.length) {
            setFile({name: undefined, base64data: undefined})
            return false;
        }

        // Read the file
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.result) {
                setFile({name: event.target.files[0].name, base64data: reader.result.toString().split(',', 2)[1]})
            }

        };
        reader.onerror = () => {
            console.error("Error reading the file. Please try again.", "error");
        };
        reader.readAsDataURL(event.target.files[0]);
    }


    return (
        <Modal
            buttons={modalButtons}
            title={'Nahrat XLSX do ' + where}
            errorObject={apiResult}
            disableAllButtons={loading}
        >
            <input className="form-control" accept=".xlsx, .xls" onChange={handleUpload} type="file" />
        </Modal>
    )

}

export default AdminUploadXLS
